import React, { useState } from "react";
import { useContext } from "react";
import "./style.css";
import { Link, NavLink } from "react-router-dom";
import Button from "../Button/Button";
import { useAuthContext } from "../../AuthContext";
import { SidebarContext } from "../Context/SidebarContext";
import TopBar from "./topBar";
import { ERROR_ROUTES } from "../../AuthContext";
import useAuth from "../../Auth";

const DesktopHeader = () => {
  const { logOut, isAuthenticated } = useAuthContext();
  const { Login } = useAuth();
  const { dispatch, state } = useContext(SidebarContext);
  const [gamePage, setGamePage] = useState(false);

  return (
    <>
      <header>
        <nav className="navbar navbar-expand-md ">
          <div className="container-1280">
            <Link className="navbar-brand" to="/home">
              <img src={require("../../Assets/img/logo.png")} alt="logo" />
            </Link>
            <button
              className="navbar-toggler header-toggle-qa"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapsibleNavbar"
            >
              <img src={require("../../Assets/img/menu-icon.png")} alt="" />
            </button>
            <div
              className={`collapse navbar-collapse ${gamePage}`}
              id="collapsibleNavbar"
            >
              <ul className="navbar-nav">
                <li className="nav-item">
                  <NavLink
                    to="games"
                    replace={true}
                    className={({ isActive }) =>
                      isActive ? "nav-link nmh-nav" : "nav-link"
                    }
                    onClick={() => setGamePage(!gamePage)}
                  >
                    Explore Games
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    replace={false}
                    to="nftjourney"
                    className={({ isActive }) =>
                      isActive ? "nav-link nmh-nav" : "nav-link"
                    }
                    onClick={() => setGamePage(!gamePage)}
                  >
                    NFTS's
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    replace={false}
                    to="/dashboard"
                    className={({ isActive }) =>
                      isActive ? "nav-link nmh-nav" : "nav-link"
                    }
                    onClick={() => setGamePage(!gamePage)}
                  >
                    Dashboard
                  </NavLink>
                </li>
                <li
                  className="nav-item last-btn"
                  onClick={() => setGamePage(!gamePage)}
                >
                  <Button
                    value={isAuthenticated ? `Disconnect` : `Connect Wallet`}
                    onClick={() => {
                      isAuthenticated ? logOut() : Login();
                    }}
                  />
                </li>
              </ul>
            </div>
          </div>
          {state.showSearch ? (
            <div className="search-icon">
              <img
                src={require("./../../Assets/img/search.png")}
                alt="search"
                onClick={() => dispatch({ type: "TOGGLE", data: true })}
              />
            </div>
          ) : (
            ""
          )}
        </nav>
      </header>
    </>
  );
};

export default DesktopHeader;
